import VideoJsAdapter from '@javascripts/adapters/videojs_adapter';
import ElementAdapter from "@javascripts/adapters/element_adapter";

export default class LoadingAnimation {
  static register() {
    VideoJsAdapter.registerPlugin('loadingAnimation', this.init);
  }

  static init() {
    var adapter;

    adapter = new VideoJsAdapter();
    adapter._instance = this;

    adapter.instance().on('ready', () => {
      new LoadingAnimation(adapter);
    });
  }

  constructor(adapter) {
    var className;
    const player = adapter;

    className = "vjs-loading-animation";
    this._el = new ElementAdapter(player.el().querySelector(".vjs-loading-spinner"));
    this._player = player;

    if (this.el().classList)
      this.el().classList.add(className);
    else
      this.el().className += ' ' + className;

    this.el().innerHTML = `
      <div id='cssload-loader'>
        <ul>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
        </ul>
      </div>
     `;

    this.onPlayerWaiting();
    this.onPlayerPlaying();
    this.onPlayerPausing();
    this.onPlayerCanPlay();
  }

  onPlayerWaiting() {
    this.player().on('waiting', () => {
      this.player().el().classList.add('vjs-buffering');
    });
  }

  onPlayerCanPlay (){
    this.player().on('canplay', () => {
      this.player().el().classList.remove('vjs-buffering');
    });
  }

  onPlayerPlaying() {
    this.player().on('playing', () => {
      this.player().el().classList.remove('vjs-buffering');
    });
  }

  onPlayerPausing() {
    this.player().on('pause', () => {
      this.player().el().classList.remove('vjs-buffering');
    });
  }

  player(){
    return this._player;
  }

  el(){
    return this._el._el;
  }
}

LoadingAnimation.register();
